import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent } from 'react';
import { Paragraph } from '../../typography';

var FormFieldDescription =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormFieldDescription, _PureComponent);

  function FormFieldDescription() {
    _classCallCheck(this, FormFieldDescription);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldDescription).apply(this, arguments));
  }

  _createClass(FormFieldDescription, [{
    key: "render",
    value: function render() {
      return React.createElement(Paragraph, _extends({
        marginTop: 0,
        size: 400,
        color: "muted"
      }, this.props));
    }
  }]);

  return FormFieldDescription;
}(PureComponent);

FormFieldDescription.displayName = "FormFieldDescription";

_defineProperty(FormFieldDescription, "propTypes", _objectSpread({}, Paragraph.propTypes));

export { FormFieldDescription as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3JtLWZpZWxkL3NyYy9Gb3JtRmllbGREZXNjcmlwdGlvbi5qcyJdLCJuYW1lcyI6WyJSZWFjdCIsIlB1cmVDb21wb25lbnQiLCJQYXJhZ3JhcGgiLCJGb3JtRmllbGREZXNjcmlwdGlvbiIsInByb3BzIiwicHJvcFR5cGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxPQUFPQSxLQUFQLElBQWdCQyxhQUFoQixRQUFxQyxPQUFyQztBQUNBLFNBQVNDLFNBQVQsUUFBMEIsa0JBQTFCOztJQUVxQkMsb0I7Ozs7Ozs7Ozs7Ozs7NkJBUVY7QUFDUCxhQUFPLG9CQUFDLFNBQUQ7QUFBVyxRQUFBLFNBQVMsRUFBRSxDQUF0QjtBQUF5QixRQUFBLElBQUksRUFBRSxHQUEvQjtBQUFvQyxRQUFBLEtBQUssRUFBQztBQUExQyxTQUFzRCxLQUFLQyxLQUEzRCxFQUFQO0FBQ0Q7Ozs7RUFWK0NILGE7O0FBQTdCRSxvQjs7Z0JBQUFBLG9CLGlDQUtkRCxTQUFTLENBQUNHLFM7O1NBTElGLG9CIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCB7IFBhcmFncmFwaCB9IGZyb20gJy4uLy4uL3R5cG9ncmFwaHknXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEZvcm1GaWVsZERlc2NyaXB0aW9uIGV4dGVuZHMgUHVyZUNvbXBvbmVudCB7XG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgLyoqXG4gICAgICogQ29tcG9zZXMgdGhlIFBhcmFncmFwaCBjb21wb25lbnQgYXMgdGhlIGJhc2UuXG4gICAgICovXG4gICAgLi4uUGFyYWdyYXBoLnByb3BUeXBlc1xuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiA8UGFyYWdyYXBoIG1hcmdpblRvcD17MH0gc2l6ZT17NDAwfSBjb2xvcj1cIm11dGVkXCIgey4uLnRoaXMucHJvcHN9IC8+XG4gIH1cbn1cbiJdfQ==